// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-64d5a3d4]{font:14px/150% Helvetica Neue,Tahoma,Arial,PingFangSC-Regular,Hiragino Sans GB,Microsoft Yahei,sans-serif;margin:0;padding:0;width:100%;min-height:100vh}.main[data-v-64d5a3d4],body[data-v-64d5a3d4]{background-color:#eff0f1}.main[data-v-64d5a3d4]{display:flex;flex-direction:column;justify-content:center;align-items:center}section[data-v-64d5a3d4]{margin-bottom:18px}section img[data-v-64d5a3d4]{max-width:980px}", ""]);
// Exports
module.exports = exports;
